import { WidgetStreamState } from 'widgets/store/stream/WidgetStreamState';
import { StreamDisableRangeDataState } from 'widgets/store/disableRange/StreamDisableRangeDataState';
import {
    VolumeCurveOrderStatData,
    VolumeCurveTimeSeriesData,
} from 'widgets/volumeCurve/api/VolumeCurveElement.ts';
import {
    StreamedStateByStreamKey,
    StreamState,
} from 'streamsState/store/streamedData/StreamedDataState.ts';

export type VolumeCurveStreamedDataStreamState =
    StreamState<VolumeCurveDataState>;

export type VolumeCurveStreamState = WidgetStreamState<VolumeCurveDataState>;

export type VolumeCurveStreamsState = StreamedStateByStreamKey<
    VolumeCurveDataState,
    VolumeCurveStreamState
>;

export interface VolumeCurveDataState extends StreamDisableRangeDataState {
    timeSeries: VolumeCurveTimeSeriesData[];
    orderStat?: VolumeCurveOrderStatData;
}

export const initialVolumeCurveDataState: VolumeCurveDataState = {
    timeSeries: [],
    disableRange: [],
};

export const initialVolumeCurveStreamState: VolumeCurveStreamState = {
    data: initialVolumeCurveDataState,
    messages: [],
};
